// src/graphql/mocks.js
export const posts = [
  {
    id: "1",
    title: "了解 Cloudflare Pages",
    content:
      "Cloudflare Pages 是一个JAMstack平台，让您可以轻松地部署静态网站...",
    author: "Chalee",
  },
  {
    id: "2",
    title: "Apollo 客户端入门",
    content: "Apollo 客户端是一个完整的数据管理解决方案，支持本地状态管理...",
    author: "李四",
  },
  {
    id: "3",
    title: "React 与 GraphQL",
    content:
      "React 和 GraphQL 是一个强大的组合，GraphQL提供了数据查询的灵活性...",
    author: "王五",
  },
  {
    id: "4",
    title: "前端模拟后端数据",
    content: "使用Apollo Client的本地状态管理功能可以在前端模拟后端数据...",
    author: "赵六",
  },
];
